module.exports = __webpack_public_path__ + "img/20-image-1-1@2x.44d14ca9.png";